import React from "react";
import {Row, Col} from "reactstrap";
export default class Forbidden extends React.Component {
    render() {
        return <div className="content">
            <Row>
            <Col md="12">
                <div className="card"  style={{textAlign:'center', marginTop:'23%'}}>
                    <span>403 Forbidden</span><br/>
                    <span>アクセス権限がありません。</span>
                </div>
            </Col>
            </Row>
        </div>
    }
}
